interface CropZone {
  id: string;
  name: string;
  [key: string]: any;
}

interface Field {
  id: string;
  name: string;
  cropzones: CropZone[];
  [key: string]: any;
}

interface Farm {
  id: string;
  name: string;
  fields: Field[];
  [key: string]: any;
}

/**
 * Granular FFT text search: filters by farm name and field name only.
 *
 * Rules:
 *  - Farm name matches → include all its fields with all their cropzones
 *  - Field name matches → include that field with all its cropzones
 *  - Farms with zero matching fields are dropped entirely
 */
const searchByTextWithinFFTGranular = (
  fft: Farm[] = [],
  textValue = ''
): Farm[] => {
  if (!textValue) return fft;

  const criteria = textValue.toLowerCase();

  return fft.reduce<Farm[]>((acc, farm) => {
    if (farm.name.toLowerCase().includes(criteria)) {
      return [...acc, farm];
    }
    const matchingFields = farm.fields.filter(field =>
      field.name.toLowerCase().includes(criteria)
    );
    if (matchingFields.length === 0) return acc;
    return [...acc, { ...farm, fields: matchingFields }];
  }, []);
};

export default searchByTextWithinFFTGranular;
